import { ComplianceControlDataQueries } from "~/pages/compliance/Control/ControlOutlets";

const FrameworkControlDataQueriesEntryPage = () => {
  return <ComplianceControlDataQueries />;
};

export default FrameworkControlDataQueriesEntryPage;
